import { Mapper } from '../../../common/ddd/mapper.base';
import {
  formatDeviation,
  formatPercentage,
} from '../../../common/utils/format-deviation.util';
import { ChallengeSelfReportAverageAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-self-report-average.aggregate-root';
import {
  AccountMetricInsightsMetricType,
  MetricValueType,
} from '../../../interface/dtos';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeSelfReportAverageAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeSelfReportAverageAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeSelfReportAverageAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeSelfReportAverageAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeSelfReportAverageAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Number(entity.beforeValue.toFixed(2)),
      afterValue: Number(entity.value.toFixed(2)),
      beforeFormattedValue: String(Math.round(entity.beforeValue)),
      afterFormattedValue: String(Math.round(entity.value)),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage:
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.beforeAverage))
          : formatPercentage(
              Math.round(
                entity.beforeAverage !== 0 ? 100 * entity.beforeAverage : 0
              )
            ),
      afterFormattedAverage:
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.average))
          : formatPercentage(
              Math.round(entity.average !== 0 ? 100 * entity.average : 0)
            ),
    };
  }
}
